import { ca } from '@cian/analytics';

import { favoriteEntityToTrackingProduct, getCustomUrl } from '../../components/Phone/tracking';
import { EDeviceType } from '../../types/device';
import { IFavoriteEntity } from '../../types/results';
import { getPageNumber } from '../../utils/trackings';

interface IPhonesEventParameters {
  entity: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
}

export function trackShowEarlyAccessPhoneClick({ entity, position, total, deviceType }: IPhonesEventParameters) {
  ca('eventEbc', {
    category: 'Phones',
    action: 'Open_favorites_early_access',
    label: getCustomUrl(entity),
    name: 'oldevent',
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
}

interface IBlockedEarlyAccessPhonesEventParameters extends IPhonesEventParameters {
  blockType: string;
}

export function trackBlockedEarlyAccessPhoneClick({
  entity,
  position,
  total,
  deviceType,
  blockType,
}: IBlockedEarlyAccessPhonesEventParameters) {
  ca('eventEbc', {
    category: 'Phones',
    action: 'Blocked_favorites_early_access',
    label: getCustomUrl(entity),
    name: 'oldevent',
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      extra: {
        block_type: blockType,
      },
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
}
